import { i18n } from '@fs/zion-locale'

export default {
  approveRework: i18n.t('Internal.approveRework', 'Approve Rework'),
  approveSuccess: i18n.t('Internal.approveSuccess', 'Approval succeeded'),
  approveFailed: i18n.t('Internal.approveFailed', 'Approval failed'),
  by: i18n.t('Internal.by', 'By:'),
  cancel: i18n.t('common-ui:cancel.action', 'Cancel'),
  cancelRework: i18n.t('Internal.cancelRework', 'Cancel Rework'),
  cancelReworkRequestSuccess: i18n.t('Internal.cancelReworkRequestSuccess', 'Cancel succeeded'),
  cancelReworkRequestFailed: i18n.t('Internal.cancelReworkRequestFailed', 'Cancel failed'),
  cancelSuccess: i18n.t('Internal.cancelSuccess', 'Cancel succeeded'),
  cancelFailed: i18n.t('Internal.cancelFailed', 'Cancel failed'),
  denyRework: i18n.t('Internal.denyRework', 'Deny Rework'),
  denySuccess: i18n.t('Internal.denySuccess', 'Deny succeeded'),
  denyFailed: i18n.t('Internal.denyFailed', 'Deny failed'),
  denyNote: i18n.t('Internal.denyNote', 'Why is this request for rework being canceled?'),
  folderRework: () => i18n.t('Internal.FolderRework', 'Folder Rework'),
  note: i18n.t('Internal.note', 'Notes:'),
  requestRework: () => i18n.t('Internal.ReworkButtons.RequestRework', 'Request Rework'),
  requestReworkSuccess: i18n.t('Internal.requestSuccess', 'Rework has been requested'),
  requestReworkFailed: i18n.t('Internal.requestFailed', 'Rework request failed'),
  reworkNote: i18n.t('Internal.reworkNote', 'Why does this folder require rework?'),
  status: i18n.t('Internal.status', 'Status:'),
  submit: i18n.t('Internal.submit', 'Submit'),
  requested: i18n.t('Internal.requested', 'Requested'),
  approved: () => i18n.t('Internal.approved', 'Approved'),
  cancelReworkRequest: () => i18n.t('Internal.cancelReworkRequest', 'Cancel Rework Request'),
}
